// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo__PgcIE","logoWithoutText":"style__logoWithoutText__vcDOs"};